import { ServiceLocation, ShoppingCart, SubmitShoppingCartResponse, UserDetails } from 'app/api/@generated/backend';

import { api } from 'app/api/common';

export class ShoppingCartService {
    public static initializeShoppingCart(
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
        broadbandOfferId: string,
    ): Promise<ShoppingCart> {
        return api.shoppingCartController.initializeShoppingCart(partnerId, {
            offerId: broadbandOfferId,
            servicePointId,
            billingAccountId,
        });
    }

    public static async submitShoppingCart(
        partnerId: string,
        shoppingCartId: string,
        numberOfResources: number,
        serviceLocation: ServiceLocation,
        userDetails: UserDetails,
    ): Promise<SubmitShoppingCartResponse> {
        const {
            address: { id: addressId },
        } = serviceLocation;
        const { firstName, lastName } = userDetails;

        return api.shoppingCartController.submitCart(partnerId, shoppingCartId, {
            addressId,
            numberOfResources,
            customerInformation: {
                firstName,
                lastName,
            },
        });
    }
}
